module.exports = __webpack_public_path__ + "img/bankbri.bf02ff86.webp";